import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import * as uScore from 'underscore';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class NotFoundComponent implements OnInit {

  customPage: any = [
    {
      key: '/notfound',
      numberError: '404',
      longText: 'Lo sentimos, pero la página que buscas no existe.',
      imgUrl: '/assets/img/imagen-construccion.png',
      otherText: ''
    },
    {
      key: '/errorcompatibility',
      numberError: '',
      longText: 'Browser no compatible.',
      imgUrl: 'https://www.cancunoncologycenter.com/wp-content/uploads/2016/04/warning-icon-hi-300x275.png',
      otherText: 'Para una mejor navegación, recomendamos los siguientes navegadores: Chrome, Firexfox, Safari o Edge.'
    },
    {
      key: '/error',
      numberError: '',
      longText: 'Eror desconocido.',
      imgUrl: 'https://www.cancunoncologycenter.com/wp-content/uploads/2016/04/warning-icon-hi-300x275.png',
      otherText: 'Hemos encontrado un problema para completar su solicitud, favor intente mas tarde.'
    }
  ];

  data: any;

  constructor(private router: Router) {
    const url = this.router.url;
    this.data = this.customPage.find( n => n.key == url);
   }

  ngOnInit(): void {

  }

}
